import React from 'react';
import Button from '../../components/ui/Button';

const UbeEducation=()=> {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="font-serif text-3xl md:text-5xl text-gray-900 mb-6 leading-tight">What is <span className="text-ube italic">real</span> ube?</h2>
            <div className="space-y-6 text-gray-600 text-lg">
              <p>Ube (pronounced oo-beh) is a purple yam native to the Philippines, loved for generations for its naturally deep violet color and flavor. We source Philippine ube from family farms.</p>
              <p>Unlike neon-purple, artificially flavored extracts common in the west, real ube has a complex flavor profile: distinct notes of <strong>vanilla, coconut, and toasted nuts</strong>.</p>
              <p>Our powder is naturally purple. No dyes, no sweeteners, just pure dried yam from the Philippines.</p>
            </div>
            <div className="mt-8"><Button to="/story" variant="outline">Read Our Story</Button></div>
          </div>
          <div className="order-1 lg:order-2 grid grid-cols-2 gap-4">
            <img src="https://media-manager-c.questera.ai/greta-media/2f6847c5255962cb7ef6c818c843620d0179d6b0e810fa4ca1144f00d96707af10e5b2228b1b15861dc89ecefec6c49b/images/aW1hZ2UvanBlZw==/dc0a359c3f4b05df08d61eae00bd0263.jpeg" alt="Farmer holding freshly harvested ube" className="rounded-2xl w-full h-64 object-cover object-center mt-8 shadow-md" />
            <img src="https://media-manager-c.questera.ai/greta-media/2f6847c5255962cb7ef6c818c843620d0179d6b0e810fa4ca1144f00d96707af10e5b2228b1b15861dc89ecefec6c49b/images/aW1hZ2UvanBlZw==/f931b541386070b533cffe7f29c81cf9.jpeg" alt="Natural ube powder with fresh purple yam" className="rounded-2xl w-full h-80 object-cover object-center shadow-lg" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default UbeEducation;